const cropNameLookup = {
  es: {
    alfalfa: 'alfalfa',
    cebada: 'barley',
    habas: 'broad beans',
    maiz: 'corn',
    arveja: 'peas',
    papa: 'potato',
    quinua: 'quinoa',
  },
  qu: {
    alfalfa: 'alfalfa',
    cebada: 'barley',
    habas: 'broad beans',
    sara: 'corn',
    alverjas: 'peas',
    papa: 'potato',
    kinuwa: 'quinoa',
  },
};

export default function getCropName(lang, crop) {
  return cropNameLookup[lang][crop];
}
